import { FinancialPositionFormType } from 'modules/onboarding/common/forms/financialPositionForm';
import { useClientFinancialPosition } from 'modules/onboarding/common/hooks/useClientFinancialPosition';

import { useOnboardingContext } from './useOnboardingContext';

export const useFinancialPosition = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { initialValues, saveFinancialPosition, submitLoading } =
    useClientFinancialPosition(data);

  const onSubmit = async (values: FinancialPositionFormType) => {
    if (values) {
      await saveFinancialPosition(values);
      goToNext();
    }
  };

  return {
    onSubmit,
    goToBack,
    submitLoading,
    initialValues,
  };
};
